import { render, staticRenderFns } from "./cow-basic-info.vue?vue&type=template&id=3565b2bf&scoped=true&"
import script from "./cow-basic-info.vue?vue&type=script&lang=js&"
export * from "./cow-basic-info.vue?vue&type=script&lang=js&"
import style0 from "./cow-basic-info.vue?vue&type=style&index=0&id=3565b2bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3565b2bf",
  null
  
)

export default component.exports